var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { PermissionEntity } from "../../../../models/manage/permissions.models";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { ManagePermissionsClientService } from "../../../../services/manage/manage-permissions.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { BindingEngine } from "aurelia-binding";
import * as Enumerable from "linq";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../constants/authentication/claims";
import { BindingSignaler } from "aurelia-templating-resources";
import { ArrayUtils } from "../../../../utilities/arrays";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { Router } from "aurelia-router";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../utilities/reflection";
import { I18N } from 'aurelia-i18n';
import { TokenClient } from "../../../../services/authentication/token-client.service";
var Permissions = /** @class */ (function () {
    function Permissions(managePermissionsService, engine, lookupsService, router, bindingSignaler, userClientService, userClaimsService, notificationService, i18N) {
        var _this = this;
        this.managePermissionsService = managePermissionsService;
        this.engine = engine;
        this.lookupsService = lookupsService;
        this.router = router;
        this.bindingSignaler = bindingSignaler;
        this.userClientService = userClientService;
        this.userClaimsService = userClaimsService;
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.canUpdatePermissions = true;
        this.checkAll = function ($event, key, permissions) {
            $event.preventDefault();
            $event.stopPropagation();
            var value = !_this.isChecked(permissions);
            var array = permissions.toArray();
            setTimeout(function () {
                array.filter(function (x) { return !x.isDisabled; }).forEach(function (x) {
                    if (x.isChecked != value) {
                        _this.assign(x, false);
                    }
                });
                setTimeout(function () {
                    _this.bindingSignaler.signal(key);
                });
            });
        };
        this.canUpdatePermissions = this.userClaimsService.hasPermission(Claims.CanUpdatePermissions);
    }
    Object.defineProperty(Permissions.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            var _this = this;
            this._searchText = value;
            setTimeout(function () {
                _this.bindingSignaler.signal('filter-permissions');
            });
        },
        enumerable: false,
        configurable: true
    });
    Permissions.prototype.activate = function (model) {
        this.name = model.name;
        model.type = Number(model.type);
        this.typeId = model.type;
        this.id = model.id;
        this.employeeIds = model.employeeIds;
        this.roleIds = model.roleIds;
        this.departmentIds = model.departmentIds;
        this.branchIds = model.branchIds;
        if (model.type === PermissionEntity.Branch) {
            this.type = this.i18N.tr('branch-text');
            this.property = "branchPermissions";
        }
        else if (model.type === PermissionEntity.Department) {
            this.type = this.i18N.tr('department-text');
            this.property = "departmentPermissions";
        }
        else if (model.type === PermissionEntity.Role) {
            this.type = this.i18N.tr('role-text');
            this.property = "rolePermissions";
        }
        else if (model.type === PermissionEntity.User) {
            this.type = this.i18N.tr('user-text');
            this.property = "userPermissions";
        }
        this.getAllPermissions();
    };
    Permissions.prototype.getAllPermissions = function () {
        var _this = this;
        if (this.permissionsUow) {
            this.permissionsUow.dispose();
        }
        setTimeout(function () {
            _this.managePermissionsService.getAllPermissions({ permissionEntity: _this.typeId, id: _this.id, branchIds: _this.branchIds, departmentIds: _this.departmentIds, roleIds: _this.roleIds, employeeIds: _this.employeeIds }).then(function (response) {
                var e_1, _a;
                // make sure for each level the permissions are not undefined or null by returning an empty array in case
                response.branchPermissions = _this.getPermissionsOrEmpty(response.branchPermissions);
                response.rolePermissions = _this.getPermissionsOrEmpty(response.rolePermissions);
                response.employeePermissions = _this.getPermissionsOrEmpty(response.employeePermissions);
                response.departmentPermissions = _this.getPermissionsOrEmpty(response.departmentPermissions);
                var _loop_1 = function (per) {
                    per.isChecked = response.currentPermissions.some(function (x) { return x.permissionId == per.dbId; });
                    isBranchPermission = response.branchPermissions.some(function (x) { return x.permissionId == per.dbId; });
                    isDepartmentPermission = response.departmentPermissions.some(function (x) { return x.permissionId == per.dbId; });
                    isRolePermission = response.rolePermissions.some(function (x) { return x.permissionId == per.dbId; });
                    isEmployeePermission = response.employeePermissions.some(function (x) { return x.permissionId == per.dbId; });
                    switch (_this.type) {
                        case "Branch":
                            break;
                        case "Department":
                            if (isBranchPermission) {
                                per.isDisabled = per.isChecked = true;
                            }
                            break;
                        case "Role":
                            if (isBranchPermission || isDepartmentPermission) {
                                per.isDisabled = per.isChecked = true;
                            }
                            break;
                        case "User":
                            if (isBranchPermission || isDepartmentPermission || isRolePermission) {
                                per.isDisabled = per.isChecked = true;
                            }
                            break;
                        default:
                            if (isBranchPermission || isDepartmentPermission || isRolePermission || isEmployeePermission) {
                                per.isDisabled = per.isChecked = true;
                            }
                            break;
                    }
                };
                var isBranchPermission, isDepartmentPermission, isRolePermission, isEmployeePermission;
                try {
                    for (var _b = __values(response.permissions), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var per = _c.value;
                        _loop_1(per);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var allPermissions = Enumerable.from(response.permissions).where(function (x) { return x.permissionCategory != null && x.permissionCategory.permissionType != null; })
                    .orderBy(function (x) { return x.permissionCategory.sequence; })
                    .groupBy(function (x) { return x.permissionCategory.permissionType.description; }, function (x) { return x; })
                    .toArray();
                _this.allPermissions = allPermissions;
                _this.entity = {};
                _this.entity[_this.property] = _this.getMappedPermissions(response.currentPermissions)
                    .concat(_this.getMappedPermissions(response.branchPermissions))
                    .concat(_this.getMappedPermissions(response.departmentPermissions))
                    .concat(_this.getMappedPermissions(response.rolePermissions))
                    .concat(_this.getMappedPermissions(response.employeePermissions));
                _this.entity[_this.property] = _this.entity[_this.property].filter(function (item1, index, inputArray) {
                    return ArrayUtils.findIndex(inputArray, function (item2) { return item1.permissionId == item2.permissionId && item1.id == item2.id; }) == index;
                });
                _this.searchText = null;
                setTimeout(function () {
                    _this.permissionsUow = UnitOfWorkObserver.getTrackingInstance(_this.engine, _this.entity, []);
                    _this.searchText = '';
                });
            }, function (e) { });
        });
    };
    Permissions.prototype.getPermissionsOrEmpty = function (arr) {
        return arr ? arr : [];
    };
    Permissions.prototype.getMappedPermissions = function (permissions) {
        return permissions.map(function (x) { return ({
            permissionId: x.permissionId,
            id: x.dbId
        }); });
    };
    Permissions.prototype.goupByCategory = function (permissions) {
        var _this = this;
        var result = Enumerable.from(permissions).where(function (x) { return x.permissionCategory != null; })
            .groupBy(function (x) { return x.permissionCategory.description; }, function (x) { return x; })
            .toArray();
        var filteredResults = result.filter(function (x) { return x.toArray().some(function (y) { return y.description.toLocaleLowerCase().indexOf(_this.searchText ? _this.searchText.toLocaleLowerCase() : '') > -1; }); });
        return filteredResults;
    };
    Permissions.prototype.groupItemsCheckboxItemsByDescription = function (permissions) {
        return Enumerable.from(permissions).orderByDescending(function (x) { return x.description; }).toArray();
    };
    Permissions.prototype.goBack = function () {
        this.router.navigateBack();
    };
    Permissions.prototype.assign = function (item, updateGroup) {
        var _this = this;
        if (updateGroup === void 0) { updateGroup = true; }
        setTimeout(function () {
            var permission = _this.entity[_this.property].filter(function (x) { return x.permissionId == item.dbId; })[0];
            if (permission) {
                var index = _this.entity[_this.property].indexOf(permission);
                _this.entity[_this.property].splice(index, 1);
                item.isChecked = false;
            }
            else {
                _this.entity[_this.property].push({ permissionId: item.dbId });
                item.isChecked = true;
            }
            if (updateGroup) {
                setTimeout(function () {
                    _this.bindingSignaler.signal(item.permissionCategory.description);
                });
            }
        });
    };
    Permissions.prototype.save = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.permissionsUow.hasChanges()) {
                _this.notificationService.show(_this.i18N.tr('no-changes-performed-text'), "", NotificationType.Info);
                resolve();
                return;
            }
            var func = function () {
                _this.getAllPermissions();
                _this.notificationService.show(_this.i18N.tr('successfully-saved-text'), _this.i18N.tr('permission-has-been-successfully-saved-text'), NotificationType.Success);
                _this.lookupsService.clearLookupCache("Branches").then(function (x) {
                    resolve();
                }).catch(function (ex) {
                    resolve();
                });
            };
            _this.managePermissionsService.save({
                permissionEntity: _this.typeId,
                id: _this.id,
                changes: _this.permissionsUow.getChanges()
            }).then(function (x) {
                _this.userClientService.reloadUser().then(function (x) {
                    func();
                }).catch(function (ex) {
                    func();
                });
            }, function (e) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('failed-to-save-text'), NotificationType.Error);
                resolve();
            });
        });
    };
    Permissions.prototype.isChecked = function (permissions) {
        return permissions.all(function (x) { return x.isChecked; });
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._searchText; })),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], Permissions.prototype, "searchText", null);
    Permissions = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ManagePermissionsClientService,
            BindingEngine,
            LookupClientService,
            Router,
            BindingSignaler,
            TokenClient,
            UserClaimsService,
            NotificationClientService,
            I18N])
    ], Permissions);
    return Permissions;
}());
export { Permissions };
